// extracted by mini-css-extract-plugin
export var SimpleHeader = "SimpleHeader-module--SimpleHeader--73f6b";
export var SimpleHeaderButton = "SimpleHeader-module--SimpleHeaderButton--2f3e4";
export var SimpleHeaderContainer = "SimpleHeader-module--SimpleHeaderContainer--5dc40";
export var SimpleHeaderLogo = "SimpleHeader-module--SimpleHeaderLogo--ba7d4";